<template>
  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><polyline points="8.6 1.1 23.4 16 8.6 30.9" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="4" /></svg>
</template>
